import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { SessionService } from '../common/session/session.service';
import { Router } from '@angular/router';
import { DetailsService } from "../details/details.service";
import { SearchService } from '../search/search.service';
import { ExhitorsService } from "../exhitors/exhitors.service";
import { TranslateService } from "@ngx-translate/core";
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogueService } from '../catalogue/catalogue.service';
import { LoginService } from '../login/login.service';
import { AnalyticsService } from '../analytics/analytics.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit  {

  @Input() item: any;
  @Input() searchConfig: object = {};
  @Input() viewType: string;
  data: any = {};
  note: string = '';
  sapCode: string = '';

  eventName: string;
  catalogueId: string;
  catalogueProperties: any = {};

  activeCustomTranslate:boolean = false;

  subCatalogues:object = {};
  subEvents = [];
  details = false;

  constructor(public utilsService:UtilsService, private sessionService: SessionService, private router:Router, public detailsService:DetailsService, 
    public searchService: SearchService, private exhibitorSvc: ExhitorsService, public translateService: TranslateService, private modalService: NgbModal,
    private loginService:LoginService, private catalogueService: CatalogueService, private analyticsService: AnalyticsService){
  }

  eventLabel = [];
  subBgColor:string = '#e33739';
  subFgColor:string = '#ffffff';
  eventData;
  hierarchicalProperties: Array<any> = [];
  listNameCategories : Array<any> = [];
  isSectorFilterActive:boolean = false;
  listSubCategories : Array<any> = [];
  sectors:Array<any>;
  categories:Array<any>;
  
  sectorMap: any = {};

  brands: boolean = false;

  unifiedCategories: Array<any> = [];

  ngOnInit(): void {
    this.searchConfig = this.searchService.getSearchConfig();
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    this.catalogueId = this.eventData['id'];
    this.eventName = this.eventData['eventName'];
    this.sapCode = this.eventData['sapCode'];
    this.eventLabel[this.sapCode] = this.eventData['label'];
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

    this.activeCustomTranslate = this.utilsService.existCustomTranslate();
    this.subCatalogues = JSON.parse(this.sessionService.get(this.sapCode + '.subCatalogues'));
    this.hierarchicalProperties = JSON.parse(this.sessionService.get(this.sapCode + '.selectedHierarchicalProperties'));
    this.sectors = JSON.parse(this.sessionService.get(this.sapCode + '.selectedSectors'));
    this.categories = JSON.parse(this.sessionService.get(this.sapCode + '.categories'));
    this.filterCategoriesByType(this.item);
    this.getSectorMap();
    this.isSectorFilterActive = JSON.parse(this.detailsService.getPropertyByKey("filter.sectors.active", true));
    this.brands = this.utilsService.isEmpty(this.searchConfig['brand']);
  }

  transformEventSapCode(eventSapCode: string): string {
    let part1 = '';
    let part2 = '';

    // Divide la cadena en dos partes
    if(eventSapCode){
      part1 = eventSapCode.slice(0, 4); // Toma los primeros 4 caracteres
      part2 = eventSapCode.slice(4);  
    }

      // Toma el resto de los caracteres
    
    // Une las partes con un punto
    return `${part1}.${part2}`;
  }

  getColorSuCataloge(item, type:string, colorDefault:string): string{
    return this.detailsService.getPropertyByKey(`colors.${this.transformEventSapCode(item.eventSapCode)}.`+ type) || colorDefault;
  }

  setImage(url: string, type: string) {
    return (!this.utilsService.isEmptyOrUndefined(url) ? url : 
      type === 'PRODUCT' ? 
        !this.utilsService.isEmptyOrUndefined(this.catalogueProperties.defaultProductImage) 
          ? this.catalogueProperties.defaultProductImage : 'assets/img/no_image_available.png' : 
      type === 'EXHIBITOR'  ? 
        !this.utilsService.isEmptyOrUndefined(this.catalogueProperties.defaultExhibitorImage) 
          ? this.catalogueProperties.defaultExhibitorImage : 'assets/img/no_image_available.png' : 'assets/img/no_image_available.png');
  }

  isSponsored(item: any): boolean {
    // Lógica para determinar si es patrocinado
    const hasSelectedProperties = Object.keys(this.searchConfig['selectedHierarchicalProperties'] !== null ? [] : this.searchConfig['selectedHierarchicalProperties'] || []).length > 0;
    const hasSelectedSectors =Object.keys(this.searchConfig['selectedSectors'] !== null ? [] : this.searchConfig['selectedSectors'] || []).length > 0;
    if (!hasSelectedProperties && !hasSelectedSectors) {
      return this.item.sponsoredInHomePage;
    }
    return this.item.sponsoredByCategories || this.item.sponsoredBySector;
  }

  isFeatured(item: any): boolean {
    // Lógica para determinar si es destacado
    return this.item.featured;
  }

  getProperty(property: string): string {
    let color = '';

    switch(property) {
      case 'colors.sponsoredColor':
          color = this.eventData['sponsoredColor'];
        break;
      case 'colors.featuredColor':
          color = this.eventData['featuredColor'];
        break;
      case 'colors.productSponsoredColor':
          color = this.eventData['productSponsoredColor'];
        break;
      case 'colors.productFeaturedColor':
          color = this.eventData['productFeaturedColor'];
        break;
      default:
          color = this.detailsService.getPropertyByKey(property, false);
        break;
    }

    return color;
  }

  goDetails() {

    const queryParams = { lang: this.utilsService.mapLanguageCode(this.translateService.currentLang)};
    let catalogueId = this.catalogueService.getProperty('id');

    this.analyticsService.sendSelectItem(this.item, this.item.type.toLowerCase(), this.viewType);

    if(this.item.type === "EXHIBITOR"){

      let entityId = (this.item.exhibitorId === null || this.item.exhibitorId === undefined) 
                        ? this.item.entityId 
                        : this.item.exhibitorId;

      this.router.navigate([`${catalogueId}/${this.eventName}/${'exhibitor'}/${entityId}/detail`], {queryParams});

    }
      

      
    if(this.item.type === "PRODUCT"){

      (this.item.exhibitorId)

      let entityId = (this.item.idProduct === null || this.item.idProduct === undefined)
                        ? this.item.entityId
                        : this.item.idProduct;
      
      this.router.navigate([`${this.eventName}/${'product'}/${entityId}/detail`], {queryParams});

    }
    
  }

  goToMaps() {
    const queryParams = { exhibitorId: this.item.entityId };
    this.router.navigate([this.eventName + '/firamaps'], {queryParams});
  }

  addToFavorites(item: any) {

    let endpoint = 'Exhibitor';
    let entityId = item.entityId || item.idExhibitor || item.idProduct;

    if (item.type === 'PRODUCT') {
      endpoint = 'Product';
    }

    this.data = {};
    this.data.eventName = this.eventName;
    this.data['id' + endpoint] = entityId;
    this.data.type = endpoint
    this.data.note = this.note;
    this.data.sapCode = this.searchConfig['sapCode'];

    if (this.loginService.isAuth()) {

      if (this.data.note.length > 255) {
        this.data.note = this.data.note.substring(0, 255);
      }

      this.exhibitorSvc.createFavoriteExhibitor(this.data).subscribe(res => {
        this.item.isFavorite = true;
        this.item.favoriteId = res.id;
        this.analyticsService.sendAddToFavorites(this.item, this.item.type.toLowerCase());
      }, err => {
        console.warn(err);
      });

    }
    else {

      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        this.exhibitorSvc.createFavoriteExhibitor(this.data).subscribe(res => {
          this.item.isFavorite = true;
          this.item.favoriteId = res.id;
          this.analyticsService.sendAddToFavorites(this.item, this.item.type.toLowerCase());
        });
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });
    }
  }

  deleteFromFavorites(item: any){

    let entityId = item.favoriteId || item.id;

    if (this.loginService.isAuth()) {
      (item.type === 'EXHIBITOR' || item.type === 'NOVELTIES') ? this.deleteFavoriteExhibitor(entityId): this.deleteFavoriteProduct(entityId);
    } else {
      const modalRef = this.modalService.open(ModalLoginComponent);
      modalRef.result.then((result) => {
        (item.type === 'EXHIBITOR' || item.type === 'NOVELTIES') ? this.deleteFavoriteExhibitor(entityId): this.deleteFavoriteProduct(entityId);
      }, (reason) => {
        //console.log('Modal dismissed with:', reason);
      });

    }
  }

  deleteFavoriteExhibitor(entityId){
    this.exhibitorSvc.deleteFavoriteExhibitor(entityId).subscribe(res => {
      this.item.isFavorite = '';
      this.item.showNote = false;
      this.item.isFavorite = false;
      this.analyticsService.sendRemoveFromFavorites(this.item, this.item.type.toLowerCase());
    }, err => {
      console.warn(err);
    });
  }

  deleteFavoriteProduct(entityId){
    this.exhibitorSvc.deleteFavoriteProduct(entityId).subscribe(res => {
      this.item.isFavorite = '';
      this.item.showNote = false;
      this.item.isFavorite = false;
      this.analyticsService.sendRemoveFromFavorites(this.item, this.item.type.toLowerCase());
    }, err => {
      console.warn(err);
    });
  }

  toggleShowNote(item: any, event: Event) {
    event.stopPropagation();
    item.showNote = item.showNote ? false: true;
  }

  cropText(text:string, maxCharacters:number=100, addEllipsis:boolean=true):string {
    return (text?.length > maxCharacters) ? `${text?.substring(0, maxCharacters)}${addEllipsis? "..." : ""}` : text;//FIXME juabe
  }

  isSector( item: any) {
    if(item.type === 'EXHIBITOR' && this.item.sectorId != ''){ 
      return this.isSectorFilterActive;
    }else{
      return false;
    }
  }

  showSubcategories(){
    if(this.categories)
      this.categories.map(res=>{
        if(this.listSubCategories.find(element => element===res.id)&& !this.listNameCategories.find(element => element.id===res.id))
        {
          {this.listNameCategories.push(res);}
        }
      });
  }

  showSector(elem){
    let show = false;
    elem.exhibitorHierarchicalProperties.map(res=>{
      if(res.hierarchicalProperty.showProperty || this.listNameCategories.find(element => element.id===res.hierarchicalProperty.id))
      {
          show = true;
      }
    });
    return show;
  }

  filterCategoriesByType(item: any){

    let hpKey = 'exhibitorHierarchicalProperties';

    if(item){
      if (item.type === 'PRODUCT') {
        hpKey = 'productHierarchicalProperties';
      }
      if(item[hpKey]){
        item[hpKey].map(sub=>{
          this.listSubCategories.push(sub.hierarchicalProperty.id);
        });
        setTimeout(()=>{ this.showSubcategories(); }, 500)
      }
    }

  }

  getSectorMap() {
    this.sectorMap = this.sectors.reduce((map, sector) => {
      map[sector.id] = sector.translations;
      return map;
    }, {});
  }

  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      this.unifiedCategories.push(categories[i]);
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }
}

